export type SosStatus = 'active' | 'acknowledged' | 'resolved' | 'escalated';
export type SosSeverity = 'low' | 'medium' | 'high' | 'critical';
export type SosSourceType = 'driver' | 'customer' | 'delivery_partner' | 'service_provider';
export type SosScope = 'active' | 'resolved' | 'all';

export interface DispatchSosUser {
  _id?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  userType?: string;
}

export interface DispatchSosAlert {
  _id: string;
  sosNumber: string;
  sourceType: SosSourceType;
  sourceUserId?: DispatchSosUser | string;
  entityType?: string;
  entityId?: string;
  location?: { coordinates?: [number, number]; address?: string };
  status: SosStatus;
  severity: SosSeverity;
  notes?: string;
  incidentReport?: string;
  resolvedBy?: DispatchSosUser | string;
  resolvedAt?: string;
  createdAt: string;
  updatedAt?: string;
}

export const SOS_STATUS_META: Record<SosStatus, { label: string; color: string }> = {
  active: { label: 'Active', color: '#ef4444' },
  acknowledged: { label: 'Acknowledged', color: '#f59e0b' },
  escalated: { label: 'Escalated', color: '#dc2626' },
  resolved: { label: 'Resolved', color: '#22c55e' },
};

export const SOS_SEVERITY_META: Record<SosSeverity, { label: string; color: string }> = {
  critical: { label: 'Critical', color: '#991b1b' },
  high: { label: 'High', color: '#ef4444' },
  medium: { label: 'Medium', color: '#f59e0b' },
  low: { label: 'Low', color: '#64748b' },
};

export const SOS_SOURCE_LABEL: Record<SosSourceType, string> = {
  driver: 'Driver',
  customer: 'Customer',
  delivery_partner: 'Delivery Partner',
  service_provider: 'Service Provider',
};

export function sosUserName(user?: DispatchSosUser | string): string {
  if (!user) return 'Unknown';
  if (typeof user === 'string') return user.slice(-6);
  return [user.firstName, user.lastName].filter(Boolean).join(' ') || 'Unknown';
}

export function sosUserPhone(user?: DispatchSosUser | string): string {
  if (!user || typeof user === 'string') return '';
  return user.phone || '';
}

export function timeSince(iso: string): string {
  const mins = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}

export function sosWorkflowStep(status: SosStatus): number {
  if (status === 'active') return 1;
  if (status === 'acknowledged') return 2;
  if (status === 'escalated') return 3;
  return 4;
}
